import { Link } from 'react-router-dom';
import './ContactCTA.css';

function ContactCTA() {
  return (
    <section id="contato" className="section contact-cta">
      <div className="container">
        <div className="contact-box">
          <h2>Vamos conversar sobre o seu projeto?</h2>
          <p>Conte como funciona o processo na sua empresa. Sem compromisso.</p>
          <div className="contact-actions">
            <a
              href="https://wa.me/5511999999999"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline btn-large"
            >
              WhatsApp
            </a>
            <Link to="/diagnostico" className="btn btn-primary btn-large">
              Solicitar Diagnóstico
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactCTA;
